import { ITreeviewChuongTrinhDaoTaoFocusedValue } from "../../../components-data/treeview-ctdt/TreeviewChuongTrinhDaoTao";
import { generateActionTypeIds } from "../generateActionTypeIds";
import IGenericActionType from "../IGenericActionType";

export type eChuongTrinhDaoTaoSoSanhTab = "xem_2_chuong_trinh" | "so_sanh";

export const eChuongTrinhDaoTaoSoSanhActionsObj = {
    INI_START: undefined,
    INI_SUCCESS: undefined,
    CHANGE_FOCUSED_TAB_START: {} as eChuongTrinhDaoTaoSoSanhTab,
    CHANGE_FOCUSED_TAB_SUCCESS: {} as eChuongTrinhDaoTaoSoSanhTab,
    CHANGE_CHUONG_TRINH_GOC_START: {} as ITreeviewChuongTrinhDaoTaoFocusedValue | undefined,
    CHANGE_CHUONG_TRINH_GOC_SUCCESS: {} as ITreeviewChuongTrinhDaoTaoFocusedValue | undefined,
    CHANGE_CHUONG_TRINH_SO_SANH_START: {} as ITreeviewChuongTrinhDaoTaoFocusedValue | undefined,
    CHANGE_CHUONG_TRINH_SO_SANH_SUCCESS: {} as ITreeviewChuongTrinhDaoTaoFocusedValue | undefined,
};

export const eChuongTrinhDaoTaoSoSanhActionIds = generateActionTypeIds(
    eChuongTrinhDaoTaoSoSanhActionsObj,
    "CHUONG_TRINH_DAO_TAO_SO_SANH"
);

export type IChuongTrinhDaoTaoSoSanhActionTypes = IGenericActionType<
    typeof eChuongTrinhDaoTaoSoSanhActionsObj,
    "CHUONG_TRINH_DAO_TAO_SO_SANH"
>;
